export default __webpack_public_path__ + "static/media/Camerron.bb47d04f.png";